import { createContext } from 'react';

interface U21ModalContextValue {
  setModalContentElement: (ref: HTMLDivElement | null) => void;
}

export const U21ModalContext = createContext<U21ModalContextValue>({
  setModalContentElement: () => {},
});
